import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import SearchDropdown from '../ymSearchDropdown/SearchDropdown';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { components as configComponents, Component } from '@app/constants/config/components';
import { categoriesList, CategoryType } from '@app/constants/categoriesList';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './HeaderSearch.styles';
import { UserOutlined } from '@ant-design/icons';

export interface HeaderSearchProps {
  query: (keyword: string, query: string) => void;
  handleSearch: (keyword: string, type: string) => void;
}

const HeaderSearch: React.FC<HeaderSearchProps> = ({ query, handleSearch }) => {
  const { mobileOnly, isTablet } = useResponsive();

  const { pathname } = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isOverlayOpen, setOverlayOpen] = useState(false);

  useEffect(() => {
    setModalOpen(false);
    setOverlayOpen(false);
  }, [pathname]);

  return (
    <>
      {mobileOnly && (
        <>
          <BaseButton
            type={isModalOpen ? 'ghost' : 'text'}
            icon={<UserOutlined onClick={() => setModalOpen(true)} />}
          />
          <S.SearchModal
            open={isModalOpen}
            closable={false}
            footer={null}
            onCancel={() => setModalOpen(false)}
            destroyOnClose
          >
            <SearchDropdown
              setSearchQuery={query}
              isOverlayOpen={isOverlayOpen}
              setOverlayOpen={setOverlayOpen}
              handleSearch={handleSearch}
            />
          </S.SearchModal>
        </>
      )}

      {isTablet && (
        <SearchDropdown
          setSearchQuery={query}
          isOverlayOpen={isOverlayOpen}
          setOverlayOpen={setOverlayOpen}
          handleSearch={handleSearch}
        />
      )}
    </>
  );
};

export default React.memo(HeaderSearch);
